// Promise-basierte Confirm-API (ersetzt window.confirm) — gleiches imperative
// Muster wie lib/toast: eine Funktion + ein registrierter Host (ConfirmHost).
export type ConfirmOptions = {
  message: string;
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
};

export type ConfirmRequest = ConfirmOptions & { resolve: (v: boolean) => void };

let _setReq: ((r: ConfirmRequest | null) => void) | null = null;

export function registerConfirmHandler(fn: ((r: ConfirmRequest | null) => void) | null) {
  _setReq = fn;
}

/**
 * Zeigt einen Bestätigungs-Dialog und löst zu true (bestätigt) / false (abgebrochen) auf.
 * Fallback auf window.confirm, falls der Host (noch) nicht gemountet ist.
 */
export function confirm(message: string, opts: Omit<ConfirmOptions, 'message'> = {}): Promise<boolean> {
  if (!_setReq) return Promise.resolve(window.confirm(message));
  return new Promise<boolean>(resolve => {
    _setReq!({ message, ...opts, resolve });
  });
}
